import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CourtGridCourt } from "../../../../models/CourtGridData";

interface UseCourtBarProps {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  availableCourts: CourtGridCourt[];
  selectedCourts: string[];
  setSelectedCourts: (courts: string[]) => void;
  currentCourtIndex: number;
}

export default function useCourtBar({
  selectedDate,
  setSelectedDate,
  availableCourts,
  selectedCourts,
  setSelectedCourts,
  currentCourtIndex,
}: UseCourtBarProps) {
  const [openFilters, setOpenFilters] = useState(false);
  const isMobile = useMediaQuery("(max-width: 980px)");

  const hasFiltersSelected = selectedCourts.length > 0 && selectedCourts.length < availableCourts.length;

  const handleClearFilters = () => {
    setSelectedCourts(availableCourts.map((court) => court.courtName));
  };

  const filteredCourts =
    selectedCourts.length > 0
      ? availableCourts.filter((court) => selectedCourts.includes(court.courtName))
      : availableCourts;

  const currentCourtName = filteredCourts[currentCourtIndex]?.courtName || "";

  return {
    openFilters,
    setOpenFilters,
    isMobile,
    hasFiltersSelected,
    filteredCourts,
    currentCourtName,
    handleClearFilters,
  };
}
